function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

require('magnific-popup');

require('magnific-popup/dist/magnific-popup.css');

var Vendor = /*#__PURE__*/function () {
  function Vendor() {
    _classCallCheck(this, Vendor);
  }

  _createClass(Vendor, null, [{
    key: "parseUaToDom",
    value: function parseUaToDom(ua) {
      var _document$documentEle2;

      var spaceRegex = /\s+/g; // devices

      if (!ua.device.type) {
        document.documentElement.classList.add('desktop');
      } else {
        var _document$documentEle;

        (_document$documentEle = document.documentElement.classList).add.apply(_document$documentEle, [ua.device.type.toKebabCase(), ua.device.vendor.toKebabCase(), ua.device.model.toKebabCase()]);
      } // browser


      var browserName = ua.browser.name.toKebabCase();

      (_document$documentEle2 = document.documentElement.classList).add.apply(_document$documentEle2, [browserName, "".concat(browserName, "-").concat(ua.browser.major)]);
    }
  }, {
    key: "wpImageBlockModals",
    value: function wpImageBlockModals() {
      $('.wp-block-image').each(function () {
        $(this).magnificPopup({
          type: 'image',
          delegate: 'a',
          removalDelay: 250,
          image: {
            titleSrc: function titleSrc(item) {
              return item.el.next('figcaption').text();
            }
          },
          mainClass: 'mfp-zoom',
          // or just mfp-fade
          zoom: {
            enabled: true,
            duration: 250,
            easing: 'ease-in-out',
            opener: function opener(openerEl) {
              return openerEl.is('img') ? openerEl : openerEl.find('img');
            }
          }
        });
      });
    }
  }, {
    key: "wpGalleryBlockModals",
    value: function wpGalleryBlockModals() {
      $('.wp-block-gallery').each(function () {
        $(this).magnificPopup({
          type: 'image',
          delegate: 'a',
          removalDelay: 250,
          image: {
            titleSrc: function titleSrc(item) {
              return item.el.next('figcaption').text();
            }
          },
          gallery: {
            enabled: true
          },
          mainClass: 'mfp-zoom',
          zoom: {
            enabled: true,
            duration: 250,
            easing: 'ease-in-out',
            opener: function opener(openerEl) {
              return openerEl.is('img') ? openerEl : openerEl.find('img');
            }
          }
        });
      });
    }
  }]);

  return Vendor;
}();

export { Vendor as default };